<div class="wrapper">

    <section class="main">

        <div class="profile-view">

            <div class="border_bottom">
                <table style="border:0 ;margin-bottom:0;">
                    <tr>
                        <td style="border:0;"><img src="assets/images/logo-nis.png" style="width:140px;"></td>

                        <td style="border:0;" class="fr">
                            <h3>e-Visa Payment Receipt</h3>
                        </td>
                    </tr>
                </table>
            </div>

            <section id="applicationdetail" class="w100 print_reciept mt15">

                <h4>Application Details</h4>
                <table>
                    <tr>
                        <td>
                            <span class="w100 pdf-label">Applicant Name</span>{{paymentReceiptDetails.applicantName}}
                        </td>

                        <td>
                            <span class="w100 pdf-label">Passport Type</span>{{paymentReceiptDetails.passportType}}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <span class="w100 pdf-label">Application
                                Number</span>{{paymentReceiptDetails.applicationIdV1}}
                        </td>

                        <td>
                            <span class="w100 pdf-label">Reference Number</span>{{paymentReceiptDetails.referenceIdV1}}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <span class="w100 pdf-label">Visa Class</span>{{paymentReceiptDetails.visaClass}}
                        </td>

                        <td>

                        </td>
                    </tr>
                </table>

                <h4>Payment Details</h4>
                <table>
                    <tr>
                        <td>
                            <span class="w100 pdf-label">Order No.</span>{{paymentReceiptDetails.orderReference}}
                        </td>

                        <td>
                            <span class="w100 pdf-label">Order Date
                                (DD/MM/YYYY)</span>{{paymentReceiptDetails.orderDate}}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <span class="w100 pdf-label">Payment Gateway</span>{{paymentReceiptDetails.paymentGateway}}
                        </td>

                        <td>
                            <span class="w100 pdf-label">Payment Mode</span>{{paymentReceiptDetails.paymentMode}}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <span class="w100 pdf-label">Payment Date
                                (DD/MM/YYYY)</span>{{paymentReceiptDetails.paymentDate}}
                        </td>

                        <td>

                        </td>
                    </tr>
                </table>

                <h4>Application Fee Details</h4>
                <div class="s-content">

                    <div style="margin-top:0;border:1px solid #cacbca;">

                        <div *ngIf="paymentReceiptDetails.isGratis === constants.TRUE" class="green_band_gratis">
                            <span style="font-size:13px;">In view of the existing bilateral agreements/arrangements,
                                your VISA is on gratis basis and no fee will be charged.</span>
                        </div>

                        <div class="sr-p-info">

                            <div>
                                <label>Visa Fee</label>
                                <p>{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.visaFee | number :
                                    '1.2' : 'en-US'}}</p>
                            </div>

                            <div *ngIf="paymentReceiptDetails.addOnfee > 0">
                                <label>Biometric Fee</label>
                                <p>{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.addOnfee | number :
                                    '1.2' : 'en-US'}}</p>
                            </div>

                            <div *ngIf="paymentReceiptDetails.serviceCharge > 0">
                                <label>Transaction Fee</label>
                                <p>{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.serviceCharge |
                                    number : '1.2' : 'en-US'}}</p>
                            </div>

                            <div style="border-bottom:0 !important;">
                                <label style="font-family:'sfui-regular';">Total Fee</label>
                                <p>{{paymentReceiptDetails.currencySymbol}}{{paymentReceiptDetails.totalFee | number :
                                    '1.2' : 'en-US'}}</p>
                            </div>

                        </div>

                    </div>

                </div>

            </section>

            <div style="width: 100%;float: left;text-align: center;padding-top: 10px;">

                <p style="font-size:8pt">This is a computer generated bill. No signature/stamp is required.</p>

            </div>

        </div>

        <div style="width: 100%;float: left;text-align: left;position:fixed;bottom:0;">

            <p>{{paymentReceiptDetails.footerContent}}</p>

        </div>

    </section>

</div>